import { FecThirdPartyStatus } from '../enums/fecThirdPartyStatus'
import type { FecThirdPartyMapping } from '../types/fecThirdPartyMapping'

export interface FecThirdPartyStatusCounts {
  existingCount: number
  newCount: number
}

export const getFecThirdPartyStatusCounts = (
  thirdPartyMappings: FecThirdPartyMapping[],
): FecThirdPartyStatusCounts => ({
  existingCount: thirdPartyMappings.filter((mapping) => mapping.status === FecThirdPartyStatus.Existing).length,
  newCount: thirdPartyMappings.filter((mapping) => mapping.status === FecThirdPartyStatus.New).length,
})
